import styled from "styled-components";

export const Container = styled.div`
  margin: 100px;
  overflow: hidden;
  @media (max-width: 786px) {
    margin:40px;
  }
  @media (max-width: 576px) {
    margin:25px;
  }

`;
export const Heading=styled.h1`
text-align:left;
font-weight:bold;
span{
  color:#f08700;

}
`;
export const ImageContainer = styled.div`
  width: 100%;
  padding-bottom: 36.25%;
  position: relative;
  overflow: hidden;
`;

export const Image = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
`;

export const TEXT=styled.p`
line-height:35px;
text-align:justify;
margin-top:25px;
`;
